module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("The")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMUNITY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("of")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_chapter01#c1"
    }
  }, [_vm._v("1 Longing for Connection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter02#c2"
    }
  }, [_vm._v("2 Remembering the Kind Embrace of Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Path to Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Power of Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Transformative Nature of Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Experiencing the Kind Caress of Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Only Kindness Allows for Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Practice of Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Giving from Plenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 We Are a Community of Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_acknowldgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_abouttherandom#atrakf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDOM")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTS OF")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDNESS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDATION")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcd8ae62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 69
// module chunks = 0